import { useMemo } from 'react';
import appRoutes from '~/appRoutes';
import { type DashboardTab, useDashboardTabs } from '~/hooks/useDashboardTabs';
import { useFormatMessage } from '~/intl';

export function useOutboundDeliveryMonitoringTabs() {
  const formatMessage = useFormatMessage();

  const tabs = useMemo<DashboardTab[]>(
    () => [
      {
        icon: 'FileEditIcon',
        id: 'outbound-contracted-volumes',
        isDynamicRoute: true,
        label: formatMessage({ id: 'dashboard.shared.deliveryMonitoring.viewsExpectedVolumes' }, { count: 2 }),
        tooltip: formatMessage({ id: 'deliveryMonitoring.tab.expectedVolumes' }),
        route: appRoutes.OUTBOUND_DELIVERY_MONITORING_CONTRACTED_VOLUMES(),
      },
      {
        icon: 'BankIcon',
        id: 'outbound-delivered-volumes',
        isDynamicRoute: true,
        label: formatMessage({ id: 'dashboard.shared.deliveryMonitoring.viewsDeliveredVolumes' }, { count: 2 }),
        tooltip: formatMessage({ id: 'deliveryMonitoring.tab.deliveredVolumes' }),
        route: appRoutes.OUTBOUND_DELIVERY_MONITORING_DELIVERED_VOLUMES(),
      },
      {
        icon: 'LinksIcon',
        id: 'outbound-reconciled-volumes',
        isDynamicRoute: true,
        label: formatMessage({ id: 'grid.column.recognisedVolume' }, { count: 2 }),
        tooltip: formatMessage({ id: 'deliveryMonitoring.tab.recognisedVolumes' }),
        route: appRoutes.OUTBOUND_DELIVERY_MONITORING_RECONCILED_VOLUMES(),
      },
    ],
    [formatMessage],
  );

  return useDashboardTabs(tabs, {
    storageDefaultValue: 'outbound-contracted-volumes',
    storageKey: 'outbound-delivery-monitoring.tab',
  });
}
